import { instance, errorService, savePreviousData } from '@/services/api'
import { templateAPIs } from '@/services/authConstantsV1'
import DynamicTable from '@/components/DynamicComponents/Templates/Grid'
import _ from 'lodash'
import Vue from 'vue'
import { showNotification } from '@/services/calculate'
import InteriorGrouping from '@/components/DynamicComponents/Templates/InteriorGrouping'
import { socketEvents } from '@/services/config'

export default {
  components: {
    DynamicTable,
    'interior-grouping': InteriorGrouping,
  },
  props: [
    'child',
    'templateData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'screen_Name',
    'projectModule',
    'type',
    'viewOnly',
    'columnSettings',
  ],
  data() {
    return {
      dropdownInfo: this.dropdownData,
      savePreviousData: savePreviousData,
      loaderTable: false,
      columnDefs: [],
      data: [],
      loader: false,
      openCreate: false,
      allPannels: [],
      create: new Vue(),
      constructionInfoData: {
        screenName: 'Speciality Information',
        id: '',
        data: {},
      },
      activeBox: null,
      activeIndex: 0,
      visible: false,
      role: null,
      screenId: 5,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      buildingData: this.templateData,
      fieldName: null,
      tabKey: undefined,
    }
  },
  beforeMount() {
    this.loadingConfig()
  },
  created() {
    this.child.$off('addNewRecord')
    this.child.$on('addNewRecord', this.addNewRecord)
  },
  mounted() {
    this.$socketHub.$on('message-received', this.messageRecieved)
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.getSpecialtyInfo()
  },
  beforeDestroy() {
    this.$socketHub.$off('message-received')
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isLocked',
          headerTooltip: 'Locked',
          width: 30,
          editable: false,
          cellRenderer: 'lockRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            viewOnly: this.viewOnly,
          },
          floatingFilter: false,
          resizable: false,
          suppressSizeToFit: true,
          hide: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          width: 5,
          hide: true,
          floatingFilter: false,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          resizable: true,
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
          },
          width: 150,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Category Code',
          suppressSizeToFit: true,
          resizable: true,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'takeoffSelectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'takeoff',
            screen: 'Template',
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Takeoff',
          resizable: true,
          width: 420,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'calculation',
            dropdownData: this.dropdownInfo.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Quantity',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Unit',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Unit Cost',
            precision: 2,
            min: 0,
          },
          width: 120,
          headerTooltip: 'Unit Cost',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            dropdownName: 'conditionFactor',
            dropdownData: this.dropdownData.condition_factor,
            name: 'conditionFactor',
            width: '350px !important',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Condition Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            name: 'multiplier',
            type: 'dynamicTable',
            dataType: 'int',
            precision: 3,
          },
          width: 100,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            screenType: 'Template',
          },
          floatingFilter: false,
          width: 60,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
          hide: this.viewOnly,
          menuTabs: [],
        },
      ]
    },

    getSpecialtyInfo() {
      this.loader = true
      const url = templateAPIs.specialtyInfo.getSpecialtyInfoDetails(
        this.$route.params.id,
      )
      instance
        .get(url)
        .then(res => {
          this.allPannels = _.get(res.data, 'result', [])
          _.get(res.data, 'result', []).forEach(element => {
            if (
              element.interiorGroupings &&
              element.interiorGroupings.length > 0
            ) {
              element.interiorGroupings.forEach(element => {
                element.takeoffs = []
                this.allPannels.push(element)
              })
            }
          })
          this.allPannels[0]['label'] = 'Building'
          this.allPannels[0].takeoffs = []
          this.activeIndex = 0
          this.activeBox = this.allPannels[0].id
          this.getPannelData(0)
          this.loader = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    getPannelData(index) {
      const panels = [...this.allPannels]
      this.loaderTable = true
      const url = templateAPIs.specialtyInfo.getTakeoffs(
        this.$route.params.id,
        this.activeBox,
      )
      instance
        .get(url)
        .then(response => {
          panels[index].takeoffs = _.get(response.data, 'result', [])
          panels[index].takeoffs.forEach(element => {
            if (element.categoryCode) {
              element.categoryCode = Number(element.categoryCode)
            }
          })
          const isValid = panels[index].takeoffs.some(i => i.isLocked)
          if (isValid) {
            const index = this.columnDefs.findIndex(
              i => i.field === 'isLocked',
            )
            this.columnDefs[index].hide = false
          }
          this.allPannels = [...panels]
          this.loaderTable = false
        })
        .catch(err => {
          this.loaderTable = false
          errorService(err)
        })
    },

    callback(index) {
      this.fieldName = null
      this.activeIndex = index
      this.activeBox = this.allPannels[index].id
      if (index === 0) {
        this.getSpecialtyInfo()
      } else {
        this.getPannelData(index)
      }
    },

    updateTakeOff(takeOff, isSocket, id, isValidTakeoff) {
      const index = this.allPannels.findIndex(i => i.id === id)
      if (index > -1) {
        this.allPannels[index].takeoffs = [...takeOff]
        this.allPannels[index].isValidTakeoff = isValidTakeoff
      }
    },

    updateBasicData(data) {
      const newData = [...this.allPannels]
      const keys = Object.keys(data)
      keys.forEach(element => {
        if (element === 'area' || element === 'perimeter') {
          this.fieldName = element
          newData[this.activeIndex][element] = Number(data[element])
        } else {
          newData[this.activeIndex][element] = data[element]
        }
      })
      this.allPannels = [...newData]
    },

    addNewRecord() {
      this.create.$emit('addRecord')
    },

    showGrouping() {
      this.visible = true
    },

    onClose(record, ids, type, key) {
      let index
      switch (type) {
        case 'add':
          this.allPannels.push(record)
          this.allPannels[0].interiorGroupings.push(record)
          break
        case 'update':
          index = this.allPannels.findIndex(i => i.id === record.id)
          this.tabKey = this.allPannels[index].id
          this.allPannels[index].label = record.label
          this.allPannels[index].value = record.value
          this.allPannels[index].area = record.area
          this.allPannels[index].perimeter = record.perimeter
          this.fieldName = key
          break
        case 'delete':
          ids.forEach(element => {
            const index = this.allPannels.findIndex(i => i.id === element.id)
            const groupIndex = this.allPannels[0].interiorGroupings.findIndex(
              i => i.id === element.id,
            )
            this.allPannels.splice(index, 1)
            this.allPannels[0].interiorGroupings.splice(groupIndex, 1)
          })
          const isDeleted = ids.some(i => i.id === this.activeBox)
          if (this.activeIndex !== 0 && isDeleted) {
            this.callback(0)
          }
          break
        case 'sequence':
          this.loader = true
          this.getSpecialtyInfo()
          break
        case 'error':
          index = this.allPannels[0].interiorGroupings.findIndex(i => i.id === record.id)
          this.allPannels[0].interiorGroupings[index].label = record.label
          this.allPannels[0].interiorGroupings[index].value = record.value
          break
        case 'refresh':
          this.getSpecialtyInfo()
          break
        default:
          this.visible = false
          break
      }
    },

    updateColumnSettings(request) {
      this.$emit('updateColumnSettings', request)
    },

    checkValidTab(id, isvalid) {
      const index = this.allPannels.findIndex(i => i.id === id)
      if (index > -1) {
        this.allPannels[index].isValidTakeoff = isvalid
      }
    },

    messageRecieved(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.templateSideBarUpdated) {
        this.$root.$emit('templateSideBarUpdated', message)
        if (this.visible) {
          if (
            this.tabKey === this.activeBox &&
            (this.fieldName === 'area' || this.fieldName === 'perimeter')
          ) {
            this.tabKey = undefined
            this.callback(this.activeIndex)
          }
        } else {
          if (this.fieldName === 'area' || this.fieldName === 'perimeter') {
            this.callback(this.activeIndex)
          }
        }
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
      }
    },
  },
}
